





















import { defineComponent, ref } from '@nuxtjs/composition-api'
import { merge } from 'lodash-es';
import useProductPage from '~/composables/useProductPage';
import { SfRadio } from '@storefront-ui/vue';

export default defineComponent({
    components:{
        SfRadio
    },
    setup() {
        const { product, addToCartConfigs, setAddToCartConfigs } = useProductPage();
        const optionModel = ref<{[key:string]:string}>({});
        const models = ref<{[key: string]: string}>({})
        if(product.value.optionsToSelect){
          product.value.optionsToSelect.forEach(opt => {
            optionModel.value[opt.attribute_code] = '';
          })
        }
        const optionChanged = (newVal)=>{
            const splitted = newVal.split('|.|')
            const key = splitted[0];
            optionModel.value[key] = newVal;
            models.value = merge({}, optionModel.value); // using another obj to select correctly. Why? I currently don't know why it doesn't work without this workaroud @CHECK
            const configKey = product.value.optionsToSelect.find(co=>co.attribute_code==key).attribute_uid
            let newConfig = {};
            newConfig[configKey] = splitted[1];
            setAddToCartConfigs(merge({},addToCartConfigs.value, newConfig));
            }
        return {
            product,
            optionChanged,
            addToCartConfigs,
            optionModel,
            models
        }
    },
})
